module.exports = require('./lib/retinable');


//////////////////
// WEBPACK FOOTER
// ./node_modules/retinable/index.js
// module id = 426
// module chunks = 58